import React from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import {
  Autocomplete,
  AutocompleteChangeReason,
  Checkbox,
  Chip,
  TextField,
} from "@mui/material";

type MultipleAutocompleteChipProps = {
  value: { id: number; name: string }[];
  onChange: (
    value: { id: number; name: string }[],
    reason: AutocompleteChangeReason,
  ) => void;
  onSearchChange?: (search: string) => void;
  options: { id: number; name: string }[];
  isLoading?: boolean;
};

export const MultipleAutocompleteChip = ({
  value = [],
  onChange = () => {},
  onSearchChange = () => {},
  options = [],
  isLoading = false,
}: MultipleAutocompleteChipProps) => {
  return (
    <Autocomplete
      multiple
      fullWidth
      disableCloseOnSelect
      loading={isLoading}
      value={value}
      options={options}
      onChange={(event, newValue, reason) => {
        onChange(newValue, reason);
      }}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderTags={(value, getTagProps) =>
        value.map((option, index: number) => (
          <Chip
            key={option.id}
            sx={{ width: "auto", alignItems: "center" }}
            label={option.name}
            deleteIcon={<CancelIcon />}
            {...getTagProps({ index })}
          />
        ))
      }
      renderOption={(props, option, { selected }) => {
        const { key, ...otherProps } =
          props as React.HTMLAttributes<HTMLLIElement> & { key: string };
        return (
          <li key={option.id} {...otherProps}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            {option.name}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={(e) => onSearchChange(e.target.value)}
          label=""
          placeholder=""
        />
      )}
    />
  );
};
